import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Polygon, Popup } from 'react-leaflet';
import { Form, FormGroup, Label, Input, Button, Container, Row, Col, Card, CardBody } from 'reactstrap';
import 'leaflet/dist/leaflet.css';
import CreateKML from '../../components/Common/Map/CreateKML';
import config from '../../config';
import BeatsGaurd from './BeatsGaurd';
import UserManagementTable from './BeatsGaurd';

const KmlManager = () => {
  const [beats, setBeats] = useState([]);
  const [datasetOptions] = useState([
    "Divisions.json",
    "Ranges.json", 
    "Rounds.json", 
    "Beats.json",
    "Comps.json"
  ]);
  const [selectedDataset, setSelectedDataset] = useState("Beats.json");

  const datasetColors = {
    "Divisions.json": { color: '#FF0000', fillColor: '#FF0000', fillOpacity: 0.2 },
    "Ranges.json": { color: '#00FF00', fillColor: '#00FF00', fillOpacity: 0.2 },
    "Rounds.json": { color: '#0000FF', fillColor: '#0000FF', fillOpacity: 0.2 },
    "Beats.json": { color: '#FFA500', fillColor: '#FFA500', fillOpacity: 0.2 },
    "Comps.json": { color: '#800080', fillColor: '#800080', fillOpacity: 0.2 }
  };

  const fetchData = async (fileName) => {
    try {
      const response = await fetch(`${fileName}`);
      if (!response.ok) throw new Error(`Failed to load ${fileName}`);
      const jsonData = await response.json();
      setBeats(jsonData);
    } catch (error) {
      console.error('Error loading data:', error);
    }
  };

  useEffect(() => {
    fetchData(selectedDataset);
  }, [selectedDataset]);

  const handleDatasetChange = (e) => {
    setSelectedDataset(e.target.value);
  };

  const getIdKey = (beat) => {
    return Object.keys(beat).find(key => key.toLowerCase().includes("id"));
  };

  const handleUpdateBeat = (beatId, updatedData) => {
    const updatedBeats = beats.map(beat => {
      const idKey = getIdKey(beat);
      return beat[idKey] === beatId ? { ...beat, ...updatedData } : beat;
    });
    setBeats(updatedBeats);
    updateJsonInS3(updatedBeats);

  };


  const updateJsonInS3 = async (updatedData) => {
    try {
      const response = await fetch(`https://controlroom-dev-asset.s3.ap-south-1.amazonaws.com/jsons/${selectedDataset}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(updatedData),
      });
  
      if (response.ok) {
        console.log("JSON successfully updated in S3!");
      } else {
        console.error("Failed to update JSON in S3:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating JSON:", error);
    }
  };
  

  const BeatPopup = ({ beat }) => {
    const [formData, setFormData] = useState({ ...beat });
    delete formData.coordinates;

    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };

    const handleAddField = () => {
      const newField = prompt("Enter new field name:");
      if (newField && !formData[newField]) {
        setFormData({ ...formData, [newField]: "" });
      }
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      const idKey = getIdKey(beat);
      handleUpdateBeat(beat[idKey], formData);
    };

    return (
      <Form onSubmit={handleSubmit} style={{ padding: '8px', width: '300px', maxHeight: '200px', overflow: 'auto' }}>
      {Object.entries(formData).map(([key, value], index) => (
        // index % 2 === 0 ? ( // Group two inputs per row
          <Row key={key} className="g-1">
            <Col>
              <FormGroup className="mb-1">
                <Label for={key} style={{ fontSize: '12px', marginBottom: '2px' }}>{key}</Label>
                : {value}
                {/* <Input id={key} name={key} value={value} onChange={handleChange} bsSize="sm" /> */}
              </FormGroup>
            </Col>
            {/* {Object.entries(formData)[index + 1] && ( // Render next input if exists
              <Col>
                <FormGroup className="mb-1">
                  <Label for={Object.entries(formData)[index + 1][0]} style={{ fontSize: '12px', marginBottom: '2px' }}>
                    {Object.entries(formData)[index + 1][0]}
                  </Label>
                  : {Object.entries(formData)[index + 1][1]}
               
                </FormGroup>
              </Col>
            )} */}
          </Row>
        // ) : null
      ))}
      
      {/* <Row className="g-1">
        <Col>
          <Button type="button" color="secondary" size="sm" block onClick={handleAddField}>
            Add
          </Button>
        </Col>
        <Col>
          <Button type="submit" color="primary" size="sm" block>
            Update
          </Button>
        </Col>
      </Row> */}
    </Form>
    
    
    );
  };
console.log('beats',beats)
  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
          <Form className="m-3">
            <FormGroup>
              <Label for="datasetSelect">Select Dataset</Label>
              <Input type="select" name="dataset" id="datasetSelect" value={selectedDataset} onChange={handleDatasetChange}>
                {datasetOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
          <h3> Total number:{beats.length}</h3>

          <MapContainer center={[ 19.5061697,79.4972909]} zoom={10} style={{ height: '70vh', width: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap contributors' />
            {beats?.map((beat, index) => {
              if (!beat.coordinates || beat.coordinates.length < 3) return null;
              const coordinates = beat.coordinates
                .filter(coord => Array.isArray(coord) && coord.length === 2)
                .map(coord => [parseFloat(coord[1]), parseFloat(coord[0])])
                .filter(coord => !isNaN(coord[1]) && !isNaN(coord[0]));
// (&& beat.compId=="0069 GOSI")
              if (coordinates.length > 2 ) {
                return (
                  <Polygon key={`${getIdKey(beat)}-${index}`} positions={coordinates} pathOptions={datasetColors[selectedDataset]}>
                    <Popup>
                      <BeatPopup beat={beat} />
                    </Popup>
                  </Polygon>
                );
              }
              return null;
            })}
          </MapContainer>

          <UserManagementTable/>
          </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  );
};

export default KmlManager;
